(function () {
  'use strict';
  if (window.MNGiveaway) return;
  var configNode = document.getElementById('mn-giveaway-config');
  if (!configNode || !window.MNGiveawayMath) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var math = window.MNGiveawayMath;
  var cart = config.initialCart || { items: [], item_count: 0 };
  var cartReady = false;
  var generation = 0;
  var refreshTimer;
  var renderPending = false;
  var serverTime = null;
  var timeAnchor = 0;
  var nativeFetch = window.fetch.bind(window);
  var useNinja = config.entryProvider === 'ninja';
  var ninja = useNinja && window.MNGiveawayNinja && window.MNGiveawayNinja.create({
    giveawayId: config.ninjaGiveawayId, publicApiKey: config.ninjaPublicApiKey, fetch: nativeFetch,
    now: now, nextBoundary: nextQuoteBoundary
  });
  var ninjaConfigured = !!(ninja && String(config.ninjaGiveawayId || '').trim() && String(config.ninjaPublicApiKey || '').trim());
  var productQuotes = new Map();
  var orderQuotes = new Map();
  var pendingProducts = new Map();
  var pendingOrders = new Map();
  var quoteLifetime = 30000;
  var banner;
  var editorNotice;
  var gpData = new WeakMap();
  function now() { return serverTime === null ? Date.now() : serverTime + performance.now() - timeAnchor; }
  function nextQuoteBoundary(time) {
    var state = math.state(config, time);
    var boundaries = [state.campaignStartsAt, state.campaignEndsAt];
    if (config.multiplierEnabled === true) boundaries.push(state.startsAt, state.endsAt);
    return boundaries.reduce(function (next, boundary) {
      return Number.isFinite(boundary) && boundary > time ? Math.min(next, boundary) : next;
    }, Infinity);
  }
  function quoteRequest() { var time = now(); return { startedAt: time, displayUntil: Math.min(time + 90000, nextQuoteBoundary(time)), validUntil: Math.min(time + quoteLifetime, nextQuoteBoundary(time)) }; }
  function quotePending(pending, key) {
    var request = pending.get(key);
    if (request && (request.validUntil <= now() || now() < request.startedAt)) { pending.delete(key); return false; }
    return !!request;
  }
  function text(node, value) { if (node.textContent !== value) node.textContent = value; }
  function visible(node, show) { if (node.hidden === show) node.hidden = !show; }
  function label(count) { return count.toLocaleString() + (count === 1 ? ' Entry' : ' Entries'); }
  function jsonAttribute(node, name) { try { return JSON.parse(node.getAttribute(name) || '{}'); } catch (_) { return {}; } }
  function attribute(node, name, value) {
    value = String(value);
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }
  function freshQuote(cache, key) {
    var quote = key && cache.get(key);
    return quote && quote.until > now() && quote.startedAt <= now() ? quote.result : null;
  }
  function displayQuote(cache, key) {
    var entry = key && cache.get(key);
    var current = freshQuote(cache, key);
    if (current && current.status === 'ready') return current;
    var good = entry && entry.good;
    return good && good.until > now() && good.startedAt <= now() ? good.result : current;
  }
  function temporaryQuoteFailure(result) {
    return !result || /^(request-failed|timeout|cooldown|rate-budget|http-429|http-5\d\d|api-TooManyRequests)$/.test(result.reason || '');
  }
  function storeQuote(cache, key, result, request) {
    var validUntil = request.validUntil;
    if (result && Number.isFinite(result.validUntil)) validUntil = Math.min(validUntil, result.validUntil);
    if (validUntil <= now() || now() < request.startedAt || result && result.reason === 'stale-response') return;
    var previous = cache.get(key);
    var good = result && result.status === 'ready'
      ? { result: result, startedAt: request.startedAt, until: request.displayUntil }
      : temporaryQuoteFailure(result) && previous ? previous.good : null;
    cache.delete(key);
    cache.set(key, { result: result || { count: null, status: 'unavailable' }, until: validUntil, startedAt: request.startedAt, good: good });
    while (cache.size > 256) cache.delete(cache.keys().next().value);
  }
  function quoteCount(result) {
    return result && result.status === 'ready' && Number.isSafeInteger(result.count) && result.count >= 0
      ? Math.min(1000, result.count) : null;
  }
  function productQuoteInput(node) {
    return { productId: node.getAttribute('data-mn-product-id'),
      variantId: node.getAttribute('data-mn-variant-id'),
      quantity: Number(node.getAttribute('data-mn-quantity') || 1),
      price: Number(node.getAttribute('data-mn-giveaway-cents')) };
  }
  function lineQuoteInput(item) {
    var data = ninja && ninja.cartData(cart);
    var index = item && (cart.items || []).indexOf(item);
    var line = data && !data.reason && data.items[index];
    // Batch products need whole unit cents; the full order endpoint accepts the
    // exact line amount even when division by quantity would lose a fraction.
    if (!line || line.price % line.quantity !== 0) return null;
    return { productId: line.productId, variantId: line.variantId,
      quantity: line.quantity, price: line.price / line.quantity };
  }
  function requestQuotes(products, snapshot) {
    if (!ninjaConfigured) return;
    var key = snapshot && ninja.cartKey(snapshot);
    if (key && !freshQuote(orderQuotes, key) && !quotePending(pendingOrders, key)) {
      var orderRequest = quoteRequest();
      pendingOrders.set(key, orderRequest);
      ninja.order(snapshot).then(function (result) {
        if (pendingOrders.get(key) === orderRequest) pendingOrders.delete(key);
        storeQuote(orderQuotes, key, result, orderRequest);
        scheduleRender();
      }).catch(function () {
        if (pendingOrders.get(key) === orderRequest) pendingOrders.delete(key);
        storeQuote(orderQuotes, key, null, orderRequest);
        scheduleRender();
      });
    }
    var fresh = [];
    products.forEach(function (input, key) {
      if (!freshQuote(productQuotes, key) && !quotePending(pendingProducts, key)) {
        var request = quoteRequest();
        pendingProducts.set(key, request);
        fresh.push({ input: input, request: request });
      }
    });
    if (fresh.length) {
      ninja.products(fresh.map(function (entry) { return entry.input; })).then(function (results) {
        fresh.forEach(function (entry) {
          var input = entry.input;
          var key = ninja.productKey(input);
          if (pendingProducts.get(key) === entry.request) pendingProducts.delete(key);
          storeQuote(productQuotes, key, results.get(key), entry.request);
        });
        scheduleRender();
      }).catch(function () {
        fresh.forEach(function (entry) {
          var input = entry.input;
          var key = ninja.productKey(input);
          if (pendingProducts.get(key) === entry.request) pendingProducts.delete(key);
          storeQuote(productQuotes, key, null, entry.request);
        });
        scheduleRender();
      });
    }

  }

  // GemPages exposes exact variant prices in its rendered product attributes.
  // Keep each counter scoped to its own product, including recommendations.
  function updateGemPages() {
    document.querySelectorAll('gp-product').forEach(function (product) {
      var prices = product.querySelectorAll('gp-product-price');
      if (!prices.length) return;
      var picker = product.querySelector('gp-product-variants');
      var data = gpData.get(product);
      var pickerRaw = picker && picker.getAttribute('gp-data');
      if (!data || data.picker !== picker || data.raw !== pickerRaw) {
        var pickerData = picker ? jsonAttribute(picker, 'gp-data') : {};
        data = { picker: picker, raw: pickerRaw, variants: pickerData.variants || [], productId: pickerData.productId };
        gpData.set(product, data);
      }
      var context = jsonAttribute(product, 'gp-context');
      var variant = context.variantSelected;
      var input = product.querySelector('input[name="id"]');
      var selectedId = input && input.value;
      var matched = data.variants.find(function (v) { return String(v.id) === selectedId; });
      if (matched) variant = matched;
      // Some GemPages templates leave the hidden id blank until add-to-cart.
      // Their visible select values identify the chosen options immediately.
      var selects = picker ? Array.from(picker.querySelectorAll('select')) : [];
      if (selects.length) {
        var values = selects.map(function (select) { return select.value; });
        var selected = data.variants.find(function (v) {
          return String(v.id) === values[0] || (v.options && values.every(function (value, i) { return v.options[i] === value; }));
        });
        if (selected) variant = selected;
      }
      if (!variant || !Number.isSafeInteger(variant.price)) return;
      prices.forEach(function (price) {
        if (jsonAttribute(price, 'gp-data').priceType === 'compare') return;
        var badge = price.nextElementSibling;
        if (!badge || !badge.hasAttribute('data-mn-gp-counter')) {
          badge = document.createElement('span');
          badge.className = 'mn-entry-badge';
          badge.hidden = true;
          badge.setAttribute('data-mn-gp-counter', '');
          badge.setAttribute('data-mn-giveaway', '');
          badge.setAttribute('data-mn-product-counter', '');
          price.insertAdjacentElement('afterend', badge);
        }
        var cents = String(variant.price);
        attribute(badge, 'data-mn-giveaway-cents', cents);
        attribute(badge, 'data-mn-product-id', context.productId || data.productId || '');
        attribute(badge, 'data-mn-variant-id', variant.id || '');
        attribute(badge, 'data-mn-quantity', 1);
        attribute(badge, 'data-mn-ineligible', variant.available === false ? 'true' : 'false');
      });
    });
  }

  function render() {
    renderPending = false;
    var currentTime = now();
    var state = math.state(config, currentTime);
    if (useNinja) {
      state.enabled = config.enabled === true;
      state.error = ninjaConfigured ? null : 'Add the Giveaway Ninja giveaway ID and public API key to connect the entry counters.';
    }
    updateGemPages();
    var orderQuote = ninja && displayQuote(orderQuotes, ninja.cartKey(cart));
    var confirmedMultiplier = orderQuote && orderQuote.status === 'ready' ? orderQuote.multiplier : null;
    var total = useNinja ? quoteCount(orderQuote) : math.cartEstimate(cart, config, currentTime);
    if (useNinja && cartReady && cart.item_count === 0) total = 0;
    var cartEstimateReady = cartReady && total !== null;
    var neededProducts = new Map();
    var ninjaFailure = null;
    document.querySelectorAll('[data-mn-giveaway-cents]').forEach(function (node) {
      var isLine = node.hasAttribute('data-mn-line-key');
      var item = isLine && (cart.items || []).find(function (line) { return line.key === node.getAttribute('data-mn-line-key'); });
      var cents = item ? item.final_line_price : Number(node.getAttribute('data-mn-giveaway-cents'));
      var show = state.enabled && (isLine ? cartReady && !!item : config.showBadges !== false);
      var count = math.estimate(cents, config, currentTime);
      if (useNinja) {
        var input = isLine ? lineQuoteInput(item) : productQuoteInput(node);
        var key = ninja && input && ninja.productKey(input);
        var quote = key && displayQuote(productQuotes, key);
        count = quoteCount(quote);
        if (show && quote && quote.status === 'unavailable') ninjaFailure = ninjaFailure || quote.reason;
        if (count !== null && confirmedMultiplier === null && Number.isSafeInteger(quote.multiplier)) confirmedMultiplier = quote.multiplier;
        if (show && key && node.getAttribute('data-mn-ineligible') !== 'true') {
          neededProducts.set(key, input);
          // Quote each real variant in the same batch. Switching sizes must not
          // consume a separate API request or guess equal-price variant awards.
          var card = !isLine && node.closest('.product-card-wrapper');
          var picker = card && card.querySelector('[data-variants]');
          var variants = picker && jsonAttribute(picker, 'data-variants');
          if (Array.isArray(variants)) variants.forEach(function (variant) {
            if (variant.available === false) return;
            var sibling = { productId: input.productId, variantId: String(variant.id), quantity: input.quantity, price: variant.price };
            var siblingKey = ninja.productKey(sibling);
            if (siblingKey) neededProducts.set(siblingKey, sibling);
          });
        }
        var quoteStatus = count !== null ? 'ready' : quote || !key || !ninjaConfigured ? 'unavailable' : 'pending';
        attribute(node, 'data-mn-entry-status', quoteStatus);
        attribute(node, 'aria-label', count === null ? quoteStatus === 'pending' ? 'Entry count loading' : 'Entry count unavailable' : label(count));
        if (isLine && count === null) show = false;
      }
      var numberNode = node.querySelector('[data-mn-entry-number]');
      if (numberNode) {
        // Update only the text targets, preserving the ticket artwork.
        text(numberNode, count === null ? '—' : count.toLocaleString());
        text(node.querySelector('[data-mn-entry-label]'), count === 1 ? 'Entry' : 'Entries');
      } else {
        text(node, count === null ? '— Entries' : label(count));
      }
      var breakdown = node.querySelector('[data-mn-entry-breakdown]');
      if (breakdown) {
        var bonusReady = useNinja && show && count !== null && quote && count === quote.count &&
          Number.isSafeInteger(quote.baseEntries) && quote.baseEntries >= 0 &&
          Number.isSafeInteger(quote.bonusEntries) && quote.bonusEntries > 0 &&
          quote.baseEntries + quote.bonusEntries === count;
        if (bonusReady) {
          text(node.querySelector('[data-mn-entry-base]'), quote.baseEntries.toLocaleString() + ' base entries');
          text(node.querySelector('[data-mn-entry-bonus]'), '+ ' + quote.bonusEntries.toLocaleString() + ' bonus');
          attribute(node, 'aria-label', label(count) + ': ' + quote.baseEntries.toLocaleString() + ' base entries plus ' + quote.bonusEntries.toLocaleString() + ' bonus entries');
        }
        visible(breakdown, !!bonusReady);
      }
      node.removeAttribute('title');
      visible(node, show && node.getAttribute('data-mn-ineligible') !== 'true');
    });
    if (useNinja && state.enabled && !document.hidden) requestQuotes(neededProducts, cartReady ? cart : null);
    document.querySelectorAll('[data-mn-cart-total]').forEach(function (node) {
      var isDock = node.hasAttribute('data-dock-entry-text');
      var numberNode = node.querySelector('[data-mn-entry-number]');
      if (numberNode) {
        // Keep the cart summary's separate number, label and caption when quantities change.
        text(numberNode, total === null ? '—' : total.toLocaleString());
        text(node.querySelector('[data-mn-entry-label]'), total === 1 ? 'Entry' : 'Entries');
      } else {
        text(node, total === null ? 'Entry count unavailable' : isDock
          ? label(total)
          : label(total) + ' in your cart');
      }
      if (isDock) node.setAttribute('aria-label', total === null ? 'Entry count unavailable'
        : label(total) + ' in your cart');
      node.removeAttribute('title');
      visible(node, state.enabled && cartEstimateReady && cart.item_count > 0);
    });
    document.querySelectorAll('[data-mn-giveaway]:not([data-mn-giveaway-cents]):not([data-mn-cart-total])').forEach(function (node) {
      visible(node, state.enabled && cartEstimateReady && cart.item_count > 0);
    });
    document.querySelectorAll('[data-dock-cart-badge]').forEach(function (node) {
      text(node, String(cart.item_count || 0));
      node.setAttribute('data-count', String(cart.item_count || 0));
      node.classList.toggle('is-hidden', !cart.item_count);
      node.style.display = cart.item_count ? '' : 'none';
    });
    if (!banner) banner = document.querySelector('[data-mn-multiplier-banner]');
    if (banner) {
      // The scheduled announcement may only show after Ninja confirms its rate.
      var multiplierConfirmed = !useNinja || confirmedMultiplier === state.multiplier;
      visible(banner, multiplierConfirmed && state.enabled && state.multiplierActive && config.showTimer !== false);
      if (state.multiplierActive) {
        var seconds = Math.max(0, Math.ceil((state.endsAt - currentTime) / 1000));
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor(seconds % 86400 / 3600);
        var minutes = Math.floor(seconds % 3600 / 60);
        text(banner.querySelector('[data-mn-multiplier-heading]'), state.multiplier + '× giveaway entries');
        text(banner.querySelector('[data-mn-multiplier-countdown]'), 'Ends in ' + (days ? days + 'd ' : '') + hours + 'h ' + minutes + 'm ' + seconds % 60 + 's');
      }
    }
    if (window.Shopify && window.Shopify.designMode) {
      if (useNinja && state.enabled && ninjaConfigured && !state.error && ninjaFailure) {
        state.error = ninjaFailure === 'api-Giveaway-Expired' || ninjaFailure === 'expired'
          ? 'Giveaway Ninja is not active for this campaign yet. Counts become available when the campaign is enabled and inside its scheduled dates.'
          : 'Giveaway Ninja could not calculate entries (' + ninjaFailure + '). Check the public key and allowed store domains in Ninja.';
      }
      if (!editorNotice) {
        editorNotice = document.createElement('p');
        editorNotice.className = 'mn-giveaway-editor-notice';
        document.body.appendChild(editorNotice);
      }
      text(editorNotice, state.error ? '187 Giveaway: ' + state.error : '');
      visible(editorNotice, !!state.error);
    }
  }
  function scheduleRender() {
    if (renderPending) return;
    renderPending = true;
    requestAnimationFrame(render);
  }

  function cartSignature(value) {
    if (!value || !Array.isArray(value.items) || value.items.some(function (item) { return !item || !item.key; })) return null;
    return JSON.stringify([value.currency, value.item_count, value.items_subtotal_price, value.total_price,
      value.items.map(function (item) {
        return [item.key, String(item.product_id), String(item.variant_id), item.quantity, item.final_line_price];
      })]);
  }
  async function exactCartDiscounts(fresh, version) {
    var data = ninja && ninja.cartData(fresh);
    if (!ninjaConfigured || config.enabled !== true || !data || data.reason !== 'discount-allocation') return fresh;
    var signature = cartSignature(fresh);
    if (!signature) return fresh;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var html = await Promise.race([
        nativeFetch(root + 'cart?section_id=mn-giveaway-cart-data', {
          credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' },
          signal: controller ? controller.signal : undefined
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart data unavailable');
          return response.text();
        }),
        new Promise(function (_, reject) {
          timer = setTimeout(function () {
            reject(new Error('Cart data timeout'));
            if (controller) controller.abort();
          }, 8000);
        })
      ]);
      if (version !== generation) return fresh;
      var page = new DOMParser().parseFromString(html, 'text/html');
      var script = page.querySelector('script[type="application/json"][data-mn-giveaway-cart-data]');
      var enriched = script && JSON.parse(script.textContent);
      if (cartSignature(enriched) !== signature) return fresh;
      var merged = Object.assign({}, fresh, { items: fresh.items.map(function (item, index) {
        var exact = enriched.items[index];
        // Keep the Ajax cart's product data; enrich only the verified discounts.
        if (item.original_line_price !== undefined && item.original_line_price !== exact.original_line_price) {
          throw new Error('Cart data changed');
        }
        return Object.assign({}, item, { original_line_price: exact.original_line_price,
          discount_allocations: exact.discount_allocations });
      }) });
      var normalized = ninja.cartData(merged);
      return normalized && !normalized.reason ? merged : fresh;
    } catch (_) {
      // The adapter returns discount-allocation until a complete matching
      // snapshot is available. Never pass gross amounts as net product prices.
      return fresh;
    } finally { clearTimeout(timer); }
  }

  async function refreshCart(version) {
    try {
      var response = await nativeFetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      var fresh = await response.json();
      if (version !== generation || !Array.isArray(fresh.items)) return;
      var date = Date.parse(response.headers.get('Date'));
      if (Number.isFinite(date)) { serverTime = date; timeAnchor = performance.now(); }
      fresh = await exactCartDiscounts(fresh, version);
      if (version !== generation) return;
      cart = fresh;
      cartReady = true;
      render();
    } catch (_) {
      // Do not show a stale cart count after a failed refresh.
      if (version === generation) { cartReady = false; render(); }
    }
  }
  function requestCartRefresh() {
    generation += 1;
    cartReady = false;
    clearTimeout(refreshTimer);
    var version = generation;
    refreshTimer = setTimeout(function () { refreshCart(version); }, 80);
    scheduleRender();
  }
  function isCartMutation(input) {
    try {
      var url = new URL(typeof input === 'string' ? input : input.url || input.href, location.href);
      return url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }
  window.fetch = function (input, options) {
    var mutation = isCartMutation(input);
    return nativeFetch(input, options).then(function (response) {
      if (mutation && response.ok) requestCartRefresh();
      return response;
    });
  };
  // Some app widgets use XHR; a successful change must refresh the same tracker.
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  var mutations = new WeakSet();
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) mutations.add(this); else mutations.delete(this);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (mutations.has(this)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) requestCartRefresh(); }, { once: true });
    return xhrSend.apply(this, arguments);
  };
  window.MNGiveaway = { refresh: requestCartRefresh, render: scheduleRender };
  document.addEventListener('cart:updated', requestCartRefresh);
  document.addEventListener('mn:cart-rendered', requestCartRefresh);
  document.addEventListener('shopify:section:load', scheduleRender);
  document.addEventListener('variant:update', function (event) {
    var detail = event.detail || {};
    var variant = detail.resource;
    var productId = detail.data && detail.data.productId;
    if (!variant || !productId || !Number.isSafeInteger(variant.price)) return;
    document.querySelectorAll('product-price [data-mn-product-counter]').forEach(function (node) {
      if (node.getAttribute('data-mn-product-id') !== String(productId)) return;
      attribute(node, 'data-mn-variant-id', variant.id);
      attribute(node, 'data-mn-giveaway-cents', variant.price);
      attribute(node, 'data-mn-ineligible', variant.available === false ? 'true' : 'false');
    });
    scheduleRender();
  });
  document.addEventListener('change', scheduleRender);
  document.addEventListener('click', scheduleRender);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) requestCartRefresh(); });
  window.addEventListener('pageshow', requestCartRefresh);
  new MutationObserver(scheduleRender).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['gp-context', 'gp-data', 'data-mn-giveaway-cents', 'data-mn-product-id', 'data-mn-variant-id', 'data-mn-quantity', 'data-mn-ineligible', 'value'] });
  render();
  requestCartRefresh();
  setInterval(render, 1000);
})();
